import React, { useState, useMemo } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import Modal from "../components/modals/Modal";
import { IconQuestionMark } from "@tabler/icons-react";

const TeritesiDij = () => {
    const { order } = useOrder();
    const navigate = useStepNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => setIsModalOpen(false);

    const handleNext = () => {
        setIsModalOpen(false);
        navigate("/Kerdesek");
    };

    const handleModify = () => {
        setIsModalOpen(false);
        navigate("/OsszesitoTablazat");
    };

    const handleBackClick = () => {
        navigate("/OsszesitoTablazat");
    };
    
    const venyekWithTotals = useMemo(() => {
        return order.venyek.map(veny => {
            const sortedComponents = veny.components
                ? [...veny.components].sort((a, b) => {
                      if (a.aidfinance_szam < b.aidfinance_szam) return -1;
                      if (a.aidfinance_szam > b.aidfinance_szam) return 1;
                      return 0;
                  })
                : [];

            const venyTotal = sortedComponents.reduce((sum, component) => {
                const price = component.component_aid_price || 0;
                return sum + price;
            }, 0);

            return { ...veny, components: sortedComponents, totalPrice: venyTotal };
        });
    }, [order.venyek]);
    
    const grandTotal = useMemo(() => {
        return venyekWithTotals.reduce((sum, veny) => sum + veny.totalPrice, 0);
    }, [venyekWithTotals]);

    const formatPrice = (price) => {
        return new Intl.NumberFormat("hu-HU").format(price) + " Ft";
    };

    return (
        <TablerLayout title="Térítési díj összesítő">
            <div className="row justify-content-center">
                <div className="col-md-10 mb-4">
                    <div className="card-body">
                        {venyekWithTotals.map((veny, idx) => (
                            <div key={idx} className="mb-4">
                                <div className="d-flex align-items-center mb-2">
                                    <h5 className="fs-4 mb-0 me-3">
                                        Vény #{idx + 1}
                                        {veny.veny_receipt && (
                                            <span className="ms-2 fs-5 text-muted" style={{ fontSize: 16 }}>
                                                ({veny.veny_receipt})
                                            </span>
                                        )}
                                    </h5>
                                </div>
                                <table className="table table-bordered table-striped align-middle">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="text-center" style={{ width: "70%" }}>Tartozék</th>
                                            <th className="text-center" style={{ width: "30%" }}>Térítési díj</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {veny.components && veny.components.length > 0 ? (
                                            <>
                                                {veny.components.map((component, i) => (
                                                    <tr key={i}>
                                                        <td>
                                                            {component.aidfinance_national}
                                                            <span className="text-muted ms-2">({component.is_left === 1 ? "Bal láb" : "Jobb láb"})</span>
                                                        </td>
                                                        <td className="text-end">
                                                            <span className="text-muted">
                                                                {component.component_aid_price 
                                                                    ? formatPrice(component.component_aid_price) 
                                                                    : "Nincs adat"}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))}
                                                {/* Összegző sor */}
                                                <tr className="table-primary">
                                                    <td className="fw-bold">Vény összesen:</td>
                                                    <td className="text-end fw-bold">{formatPrice(veny.totalPrice)}</td>
                                                </tr>
                                            </>
                                        ) : (
                                            <tr>
                                                <td colSpan={2} className="text-center text-muted">
                                                    Nincs kiválasztott tartozék.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        ))}
                        
                        {/* Végösszeg kártya */}
                        <div className="card bg-light border-primary mt-4 mb-3">
                            <div className="card-body d-flex justify-content-between align-items-center">
                                <h4 className="card-title mb-0">Teljes térítési díj:</h4>
                                <h3 className="card-text text-primary mb-0">{formatPrice(grandTotal)}</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-between mt-4">
                    <StepperNavButton side="left" label="Vissza" onClick={handleBackClick} />
                    <StepperNavButton side="right" label="Tovább" onClick={handleOpenModal} />
                </div>
            </div>
            <Modal isOpen={isModalOpen} onClose={handleCloseModal} onSecondary={handleModify} onConfirm={handleNext} title="Térítési díj megerősítése" type="warning" confirmText="Igen" secondaryText="Módosítás" confirmClass="btn btn-primary" secondaryClass="btn btn-danger" showSecondary={true} showCancel={false} icon={<IconQuestionMark size={70} stroke={2} className="text-warning" />}>
                <h4>Térítési díjat megismerte és elfogadta a megrendelő?</h4>
                <p className="mt-3 fs-5">
                    Fizetendő összeg: <span className="text-primary fw-bold">{formatPrice(grandTotal)}</span>
                </p>
            </Modal>
        </TablerLayout>
    );
};

export default TeritesiDij;
